import React, {useEffect, useMemo, useState} from 'react';
import Container from '@wearesection/bandai-react-components/atoms/Container';
import {Box, Link} from '@mui/material';
import SocialShare from '@wearesection/bandai-react-components/molecules/SocialShare';
import {documentToReactComponents} from '@contentful/rich-text-react-renderer';
import * as Types from 'graphql/types';
import {getOptions} from './body-rich-text-renderer-options';
import dynamic from 'next/dynamic';
import {useRouter} from 'next/router';
import HtmlRenderer from '@wearesection/bandai-react-components/atoms/HtmlRenderer';
import {getOptionsNews} from './body-rich-text-renderer-options-new';
const PasswordProtectDynamic = dynamic(
  () => import('@wearesection/bandai-react-components/organisms/PasswordProtect'),
  {ssr: false}
);

type IBodyArticleProps = {
  content: Types.News['content'];
  label: string;
  fbShare: string;
  instaShare: string;
  twShare: string;
  customTags: Array<string>;
  isProtectedPassword?: boolean;
  passwordDescription?: Types.News['content'];
  idNew?: string;
  handleDisableProtect?: Function;
  isBlog?: boolean;
  dataTranslation?: any;
  weiboShare: string;
  kakaoShare: string;
  titleCopiedToClipboard?: string;
};

const BodyArticleOrganisms: React.FC<IBodyArticleProps> = (props: any) => {
  const {
    content,
    label,
    fbShare,
    instaShare,
    twShare,
    customTags = [],
    isProtectedPassword,
    passwordDescription,
    idNew,
    handleDisableProtect,
    isBlog,
    dataTranslation,
    weiboShare,
    kakaoShare,
    titleCopiedToClipboard,
    uiContent,
  } = props;
  const isNewUI = uiContent === 'Style 2';

  const [layoutPassword, setLayoutPassword] = useState(isProtectedPassword ?? false);
  const [stateError, setStateError] = useState('');
  const [isShowWeibo, setIsShowWeibo] = useState(false);
  const [isShowkakao, setIsShowkakao] = useState(false);
  const [newTag, setNewTag] = useState<any[]>([]);
  const [isContentHtml, setIsContentHtml] = useState<boolean>(false);
  const [dataContentHtml, setDataContentHtml] = useState<any>('');

  const router = useRouter();
  const {locale} = router;
  useEffect(() => {
    const newLocales = locale?.toLowerCase();

    if (
      newLocales === 'hk-tc' ||
      newLocales === 'hk-sc' ||
      newLocales === 'tw-tc' ||
      newLocales === 'tw-sc'
    ) {
      setIsShowWeibo(true);
    }
    if (newLocales === 'ko-kr') {
      setIsShowkakao(true);
    }
  }, [locale]);

  useEffect(() => {
    if ((content?.json?.content || []).length === 1) {
      setIsContentHtml(true);
      setDataContentHtml(content?.json?.content[0]?.content?.[0]?.value || '');
    }
  }, [content]);

  useEffect(() => {
    setNewTag(customTags || []);
  }, [customTags]);

  const handleCheckPassWord = (e: string) => {
    if (e === idNew) {
      setLayoutPassword(false);
      handleDisableProtect();
    } else {
      setLayoutPassword(true);
      setStateError(Date.now().toString());
    }
  };
  const renderTag = useMemo(() => {
    return (
      <Container
        sx={{
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            maxWidth: '740px',
            width: '100%',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'wrap',
              marginTop: {
                xs: '32px',
                md: '60px',
              },
              '& a': {
                fontWeight: '600',
                position: 'relative',

                '&:before': {
                  content: "''",
                  position: 'absolute',
                  width: '100%',
                  left: '0px',
                  bottom: '0px',
                  borderBottom: '1px solid #737373',
                },
              },
            }}
          >
            {newTag.map((tag: any) => {
              const hef = isBlog ? `/${locale}/blog?tag=${tag}` : `/${locale}/news?tag=${tag}`;
              return (
                <Link
                  key={tag}
                  href={hef}
                  sx={{
                    textDecoration: 'none',
                    marginRight: tag ? '24px' : '0px',
                  }}
                >
                  {tag}
                </Link>
              );
            })}
          </Box>
        </Box>
      </Container>
    );
  }, [newTag, isBlog, locale]);

  return (
    <Box
      sx={{
        padding: '0px',
        paddingTop: {
          xs: '16px',
          lg: '44px',
        },
        paddingBottom: {
          xs: '72px',
          lg: '80px',
        },
      }}
      className="body-article-container"
    >
      <Container
        sx={{
          display: layoutPassword ? 'flex' : 'none',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            maxWidth: '740px',
            width: '100%',
          }}
        >
          <Box>
            <PasswordProtectDynamic
              description={documentToReactComponents(
                passwordDescription?.json,
                getOptions(passwordDescription)
              )}
              stateError={stateError}
              handleCheckPassWord={handleCheckPassWord}
              formPassword={{
                title: dataTranslation['news-detail-password-protected-title'],
                childrenBtn: dataTranslation['news-detail-password-protected-button-text'],
                textInput: {
                  errorText:
                    dataTranslation['news-detail-password-protected-wrong-password-error-text'],
                  placeholder: dataTranslation['news-detail-password-protected-placeholder'],
                  isEmpty:
                    dataTranslation['news-detail-password-protected-empty-password-error-text'],
                },
              }}
            />
          </Box>
        </Box>
      </Container>

      <Box
        sx={{
          display: layoutPassword ? 'none' : 'flex',
          flexDirection: 'column',
          width: '100%',
          color: '#737373',
          margin: '0 auto',
          '& ul li::marker': {
            color: '#737373',
          },
          '& img': {
            width: '100%',
            height: 'auto',
            objectFit: 'contain',
            borderRadius: '20px',
          },
          '& a': {
            color: '#737373',
            textDecoration: 'none',
          },
          '& .event-wrapper': {
            textAlign: 'center',
            '& .btn': {
              height: '46px',
              backgroundColor: '#1e1e1e',
              display: 'inline-flex',
              alignItems: 'center',
              borderRadius: '90px',
              padding: '0px 28px',
              color: '#fff',
              margin: '40px 0 60px 0',
              fontSize: '16px',
              fontWeight: 600,
              minWidth: '148px',
              textAlign: 'center',
              justifyContent: 'center',
              '&:hover': {
                backgroundColor: '#E60000',
              },
            },
          },
          '& figure': {
            margin: '0px',
          },
          '& iframe': {
            borderRadius: isNewUI ? '0px' : '20px',
            width: '100%',
          },
        }}
      >
        {isContentHtml && !isNewUI ? (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              width: '100%',
              padding: '0px 24px ',
              color: '#737373',
              margin: '0 auto',
              '& ul li::marker': {
                color: '#737373',
              },
              '& img': {
                width: '100%',
                height: 'auto',
                objectFit: 'contain',
                borderRadius: '20px',
                margin: {
                  xs: '32px 0px',
                  md: '40px 0px',
                },
              },
              '& a': {
                color: '#737373',
                textDecoration: 'none',
              },
              '& .event-wrapper': {
                textAlign: 'center',
                '& .btn': {
                  height: '46px',
                  backgroundColor: '#1e1e1e',
                  display: 'inline-flex',
                  alignItems: 'center',
                  borderRadius: '90px',
                  padding: '0px 28px',
                  color: '#fff',
                  margin: '40px 0 60px 0',
                  fontSize: '16px',
                  fontWeight: 600,
                  minWidth: '148px',
                  textAlign: 'center',
                  justifyContent: 'center',
                  '&:hover': {
                    backgroundColor: '#E60000',
                  },
                },
              },
              '& figure': {
                margin: '0px',
              },
              '& iframe': {
                borderRadius: isNewUI ? '0px' : '20px',
              },
            }}
          >
            <Box
              sx={{
                width: '100%',
                maxWidth: {
                  xs: '672px',
                  lg: '930px',
                },
              }}
            >
              {dataContentHtml && <HtmlRenderer component="div" value={dataContentHtml} />}
            </Box>
          </Box>
        ) : isNewUI ? (
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              padding: {
                xs: '0px 24px',
                md: '0px 32px',
                lg: '0px',
              },
              '& code': {
                display: 'flex',
                width: '100%',
                justifyContent: 'center',
                '& span': {
                  textAlign: 'center',
                },
              },

              '& .italic': {
                fontStyle: 'italic',
              },

              '& .bold': {
                fontWeight: '700',
              },
            }}
          >
            {documentToReactComponents(
              content?.json,
              getOptionsNews(content, isBlog, dataTranslation)
            )}
          </Box>
        ) : (
          documentToReactComponents(content?.json, getOptions(content, isBlog, dataTranslation))
        )}
        {renderTag}
      </Box>

      <Container
        sx={{
          marginTop: layoutPassword ? '32px' : '60px',
        }}
      >
        <Box
          sx={{
            margin: '0px auto',
            maxWidth: '740px',
            '& div': {
              display: 'flex',
              '& a': {
                lineHeight: '0px',
                marginRight: {
                  xs: '24px ',
                  md: '32px ',
                },
              },
            },
          }}
        >
          <SocialShare
            label={label}
            fbShare={fbShare}
            instaShare={instaShare}
            twShare={twShare}
            hrefShare={true}
            weiboShare={isShowWeibo ? weiboShare : ''}
            kakaoShare={isShowkakao ? kakaoShare : ''}
            titleCopiedToClipboard={titleCopiedToClipboard || ''}
          />
        </Box>
      </Container>
    </Box>
  );
};

export default BodyArticleOrganisms;
